import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {inject, observer, useLocalObservable} from "mobx-react";
import TicketField from "../components/form/TicketField";
import PrimaryButton from "../components/PrimaryButton";
import axios from "axios";
import {useSpring, animated} from "@react-spring/web";

function WaitingList({DeviceStore}){

  const {organisation_slug, shop_id} = useParams();
  const navigate = useNavigate();

  const {eventData, apiUrl, t} = DeviceStore;

  const springs = useSpring({
    from: { x: 25, opacity: 0, },
    to: { x: 0, opacity: 1 },
  })


  useEffect(() => {
    if(!eventData) {
      navigate(`/${organisation_slug}/${shop_id}`);
    }
    return;
  },[]);

  const ticketOptions = eventData?.tickets.filter(t => t.type !== 'voucher').reduce((acc, item) => {
    acc[item.id] = t(item.name);
    return acc;
  }, {});

  const goBack = () => {
    navigate(`/${organisation_slug}/${shop_id}`);
    if(DeviceStore.iframe) {
      window.scrollTo(0, 0);
      window.parent.postMessage({
        type: 'scrollTop',
      }, "*");
    }
  }

  const state = useLocalObservable(() => ({
    loading: false,
    sent: false,
    first_name: '',
    last_name: '',
    email: '',
    tickettype: '',
    tickets: '',
  }));


  if(!eventData){
    return null;
  }

  const submit = async (e) => {

    e.preventDefault();

    if(state.loading) return;

    state.loading = true;

    try {
      await axios.post(apiUrl + `/shop/${organisation_slug}/${shop_id}/waiting-list`, {
        first_name: state.first_name,
        last_name: state.last_name,
        email: state.email,
        tickettype_id: state.tickettype,
        tickets: state.tickets,
      });
      state.sent = true;
    } catch (e) {
      DeviceStore.setError(e.response?.data?.message || 'Er ging iets fout, probeer het later nog eens.')
    }

    state.loading = false;
  }

  return (
      <animated.form style={springs} onSubmit={submit}>
      <div className="card mb-4 p-4">
        <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100">
          {t('waiting_list')}
        </h3>
        <div className="mt-4 space-y-4">

          <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-4 dark:border-gray-700">
            <label htmlFor="first_name" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 dark:text-gray-300">
              <span className="form-field-label">
                {t('firstname')}<span className="required text-red-500">*</span>
              </span>
            </label>
            <div className="mt-1 sm:mt-0 sm:col-span-2 max-w-sm">
              <TicketField
                  value={state.first_name}
                  onChange={({target}) => state.first_name = target.value}
                  field={{
                    type: 'text',
                    name: "first_name",
                    required: true
                  }}/>
            </div>
          </div>

          <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-4 dark:border-gray-700">
            <label htmlFor="last_name" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 dark:text-gray-300">
              <span className="form-field-label">
                {t('lastname')}<span className="required text-red-500">*</span>
              </span>
            </label>
            <div className="mt-1 sm:mt-0 sm:col-span-2 max-w-sm">
              <TicketField
                  value={state.last_name}
                  onChange={({target}) => state.last_name = target.value}
                  field={{
                    type: 'text',
                    name: "last_name",
                    required: true
                  }}/>
            </div>
          </div>

          <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-4 dark:border-gray-700">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 dark:text-gray-300">
              <span className="form-field-label">
                {t('email')}<span className="required text-red-500">*</span>
              </span>
            </label>
            <div className="mt-1 sm:mt-0 sm:col-span-2 max-w-sm">
              <TicketField
                  value={state.email}
                  onChange={({target}) => state.email = target.value}
                  field={{
                    type: 'email',
                    name: "email",
                    required: true
                  }}/>
            </div>
          </div>

          <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-4 dark:border-gray-700">
            <label htmlFor="tickets" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 dark:text-gray-300">
              <span className="form-field-label">
                {t('desired_tickets')}<span className="required text-red-500">*</span>
              </span>
            </label>
            <div className="mt-1 sm:mt-0 sm:col-span-2 max-w-sm">
              <TicketField
                  value={state.tickettype}
                  onChange={({target}) => state.tickettype = target.value}
                  field={{
                    options: ticketOptions,
                    type: 'select',
                    name: "tickettype",
                    required: true
                  }}/>
            </div>
          </div>

          <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-4 dark:border-gray-700">
            <label htmlFor="tickets" className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 dark:text-gray-300">
              <span className="form-field-label">
                {t('desired_tickets_amount')}<span className="required text-red-500">*</span>
              </span>
            </label>
            <div className="mt-1 sm:mt-0 sm:col-span-2 max-w-sm">
              <TicketField
                  value={state.tickets}
                  onChange={({target}) => state.tickets = target.value}
                  field={{
                    type: 'number',
                    name: "tickets",
                    required: true
                  }}/>
            </div>
          </div>
        </div>


      </div>

        <div className="mt-4 card p-4 md:p-6">
          {!state.sent ? <div className="flex justify-between">

                <div>
                  <button type="button" onClick={goBack} className="back-btn text-sm p-4 py-2 h-10 rounded-full font-bold bg-gray-100 dark:bg-gray-900 text-gray-800 cursor-pointer dark:text-gray-200">{t('back')}</button>
                </div>
                <PrimaryButton loading={state.loading} type="submit" theme={eventData.theme} label={t('subscribe')}/>


              </div> :
              <div className="p-2 rounded font-bold px-4 bg-green-500 text-white">{t('waiting_list_success')}</div>}
        </div>

      </animated.form>
  )

}

export default inject('DeviceStore')(observer(WaitingList));
